import { jsx as _jsx } from "react/jsx-runtime";
import { BLUE_500, InfoIcon, Tooltip, getTestId, useBreakpoint } from '@airtel/air-design-system';
import { useState } from 'react';
import { Pressable } from 'react-native';
import { getSectionTitleWidgetStyles } from '../../SectionTitleWidgetStyles';
export var SectionTitleTooltip = props => {
  var _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'SectionTitleTooltip' : _props$testID,
    infoIconTooltipProps = props.infoIconTooltipProps,
    showOnMountInfoIconTooltip = props.showOnMountInfoIconTooltip,
    infoIconPress = props.infoIconPress;
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var sectionTitleWidgetStyles = getSectionTitleWidgetStyles();
  var _useState = useState(showOnMountInfoIconTooltip),
    showTooltip = _useState[0],
    setShowTooltip = _useState[1];
  return _jsx(Tooltip, Object.assign({
    position: isLargeScreen ? 'bottom-start' : 'bottom-end',
    offset: {
      x: -10,
      y: -6
    }
  }, infoIconTooltipProps, {
    isVisible: showTooltip,
    onClose: () => {
      if (infoIconTooltipProps === null || infoIconTooltipProps === void 0 ? void 0 : infoIconTooltipProps.autoHide) {
        setShowTooltip(false);
      }
    }
  }, getTestId(testID, 'showInfoIcon'), {
    children: _jsx(Pressable, Object.assign({
      onPress: () => {
        setShowTooltip(!showTooltip);
        infoIconPress === null || infoIconPress === void 0 ? void 0 : infoIconPress();
      }
    }, {
      children: _jsx(InfoIcon, Object.assign({
        color: BLUE_500,
        fontSize: 16,
        style: sectionTitleWidgetStyles.infoIcon
      }, getTestId(testID, 'infoIcon')))
    }))
  }));
};